import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Checkbox,
    Button,
    CircularProgress
} from '@material-ui/core';
import { injectIntl } from 'react-intl';

import { withRouter } from 'react-router-dom';
import { tConvert, getDay } from '../../utils/config/constants';
import { NotificationManager } from 'react-notifications';
import DateTimePanel from './DateTimePanel';
import moment from 'moment';
import TimePickerPopup from './TimePickerPopup';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
class BusinessHours extends React.Component {
    constructor(props) {
        super();
        this.selectedIndex = 0;
        this.selectedType = 'start';
        this.state = {
            page: 1,
            loaderButton: false,
            scrollClicked: false,
            detailRender: false,
            bookingSelected: '',
            showScroll: true,
            timeValue: "12:00 AM",
            isDateTimePickerVisible: false,
            timeLoader: false,
            timingData: [
                {
                    key: '1',
                    day: 'Monday',
                    status: false,
                    startTime: '10:00 PM',
                    endTime: '7:00 PM'
                },
                {
                    key: '2',
                    day: 'Tuesday',
                    status: false,
                    startTime: '10:00 PM',
                    endTime: '7:00 PM'
                },
                {
                    key: '3',
                    day: 'Wednesday',
                    status: false,
                    startTime: '10:00 PM',
                    endTime: '7:00 PM'
                },
                {
                    key: '4',
                    day: 'Thursday',
                    status: false,
                    startTime: '10:00 PM',
                    endTime: '7:00 PM'
                },
                {
                    key: '5',
                    day: 'Friday',
                    status: false,
                    startTime: '10:00 PM',
                    endTime: '7:00 PM'
                },
                {
                    key: '6',
                    day: 'Saturday',
                    status: false,
                    startTime: '10:00 PM',
                    endTime: '7:00 PM'
                },
                {
                    key: '7',
                    day: 'Sunday',
                    status: false,
                    startTime: '10:00 PM',
                    endTime: '7:00 PM'
                }
            ]
        };
    }
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        this.props.getBusinessHoursAction(this.onDone);
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ timingData: data.data.timing_packet });
        } else {
            NotificationManager.error(data.message, 'Error');
        }
    };

    handleClick = index => {
        const timingData = [...this.state.timingData];
        timingData[index].status = !timingData[index].status;
        this.setState({ timingData });
    };
    onStartTimePress = index => {
        this.selectedType = 'start';
        this.selectedIndex = index;
        this.setState({ isDateTimePickerVisible: true });
    };
    onEndTimePress = index => {
        this.selectedType = 'end';

        this.selectedIndex = index;
        this.setState({ isDateTimePickerVisible: true });
    };

    onChangeDate = event => {
        console.log("TIMEEEMMEMFM::", event)
        const dateTimeValue = moment(event).format('hh:mm A');
        console.log("TIMEEEMMEMFM VAlueeee::", dateTimeValue)

        this.setState({ timeValue: dateTimeValue });
    };
    handleClose = () => {
        this.setState({ isDateTimePickerVisible: false });
    };
    renderTimePicker = key => {
        return (
            <DateTimePanel
                key={key}
                open={true}
                dateFormat={false}
                timeFormat={true}
                onChange={this.onChangeDate}
                value={this.dateTimeValue}
            />
        );
    };
    saveDate = () => {
        const { timeValue } = this.state;
        this.setState({ timeLoader: true });
        const timingData = [...this.state.timingData];
        if (this.selectedType === 'start') {
            timingData[this.selectedIndex].startTime = timeValue;
        } else if (this.selectedType === 'end') {
            timingData[this.selectedIndex].endTime = timeValue;
        }
        this.setState({
            timingData: timingData,
            isDateTimePickerVisible: false,
            timeLoader: false
        });
    };
    updateBusinessHours = () => {
        this.setState({ loaderButton: true });
        this.props.updateTimingPacketAction(
            {
                timingPacket: this.state.timingData
            },
            this.onUpdateDone
        );
    };
    onUpdateDone = (success, data) => {
        this.setState({ loaderButton: false });
        if (success) {
            NotificationManager.success(data.message, 'Success');
        } else {
            NotificationManager.error(data.message, 'Error');
        }
    };
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    className="custom-button"
                    onClick={this.updateBusinessHours}
                >
                    UPDATE
                </button>
            );
        }
    };
    render() {
        const { classes } = this.props;
        const { formatMessage } = this.props.intl;
        const { timingData, isDateTimePickerVisible } = this.state;

        if (this.state.detailRender) {
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.bookingSelected}`,
                bookingId: this.state.bookingSelected
            });
        }
        return (
            <div>
                <div className="ds-boar-title mb-4">
                    <h4>Manage your working Hours</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <List className={classes.root}>
                            {timingData.map(timing => {
                                return (
                                    <ListItem
                                        key={timing.key}
                                        className={classes.paper}
                                    >
                                        <ListItemAvatar>
                                            <Checkbox
                                                checked={timing.status}
                                                onChange={() =>
                                                    this.handleClick(timing.key)
                                                }
                                                value={timing.key}
                                                color="primary"
                                            />
                                        </ListItemAvatar>

                                        <ListItemText
                                            disableTypography={true}
                                            primary={
                                                <React.Fragment>
                                                    <h5>{timing.day}</h5>
                                                </React.Fragment>
                                            }
                                        />
                                        <ListItemSecondaryAction className="list-text-manage">
                                            <div className="d-flex">
                                                <p
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() =>
                                                        this.onStartTimePress(
                                                            timing.key
                                                        )
                                                    }
                                                >
                                                    {timing.startTime}
                                                </p>

                                                <p> - </p>
                                                <p
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() =>
                                                        this.onEndTimePress(
                                                            timing.key
                                                        )
                                                    }
                                                >
                                                    {timing.endTime}
                                                </p>
                                            </div>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </div>
                    <div className="col-md-12 d-flex justify-content-center">
                        {this.renderButton()}
                    </div>
                </div>
                <TimePickerPopup
                    isVisible={this.state.isDateTimePickerVisible}
                    onChangeDate={this.onChangeDate}
                    dateTimeValue={this.state.dateTimeValue}
                    closePopup={this.handleClose}
                    dateFormat={false}
                    timeFormat={true}
                    open={this.state.isDateTimePickerVisible}
                    saveDate={this.saveDate}
                    loaderButton={this.state.timeLoader}
                />
            </div>
        );
    }
}

// const mapStateToProps = ({ bookings }) => {
//     return {
//         bookingData: bookings.bookingData.bookingList,
//         bookingLoader: bookings.bookingLoader
//     };
// };
const composedComponent = compose(
    withStyles(styles),
    connect(
        null,
        actions
    )
);
export default composedComponent(withRouter(injectIntl(BusinessHours)));



// WEBPACK FOOTER //
// ./src/components/Providers/BusinessHours.jsx